import { render, staticRenderFns } from "./Profil.vue?vue&type=template&id=363f3cd4&"
import script from "./Profil.vue?vue&type=script&lang=ts&"
export * from "./Profil.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports